import { format, addMonths, addDays } from 'date-fns';

export function convertRecurrenceToPaymentPeriodInstallments(recurrence: number) {
  switch (recurrence) {
    case 1:
      return 'Pagamento mensal';
    case 3:
      return 'Pagamento trimestral';
    case 12:
      return 'Pagamento anual';
    default:
      return '';
  }
}

export function convertRecurrenceToPaymentNextBilling(recurrence: number, periodicity?: string) {
  if (periodicity === 'days') {
    return format(addDays(new Date(), recurrence), 'dd/MM/yyyy');
  }

  return format(addMonths(new Date(), recurrence), 'dd/MM/yyyy');
}

export function formatCouponMessageError(error: string) {
  switch (error) {
    case 'coupon_not_found':
      return 'Cupom não encontrado';
    case 'coupon_inactive':
      return 'Cupom não encontrado';
    case 'coupon_limit_expired':
      return 'Cupom expirado';
    case 'coupon_allowed_for_restricted_emails':
      return 'Cupom não encontrado';
    case 'coupon_not_allowed_for_this_plan':
      return 'Cupom não aplicável para este produto';
    case 'coupon_allowed_for_restricted_plans':
      return 'Cupom não aplicável para este produto';
    case 'coupon_not_allowed_for_this_user':
      return 'Seu e-mail não está autorizado para uso deste cupom';
    case 'coupon_not_allowed':
      return 'Cupom não permitido';
    default:
      return '';
  }
}

export const formatCardNumber = (value: string) => {
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  const matches = v.match(/\d{4,16}/g);
  const match = (matches && matches[0]) || '';
  const parts = [];
  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }
  if (parts.length) {
    return parts.join(' ');
  }
  return v;
};

export const formatExpiry = (value: string) => {
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
  if (v.length >= 2) {
    return `${v.substring(0, 2)}/${v.substring(2, 4)}`;
  }
  return v;
};

export const formatCpfMasked = (digits: string) => {
  const d = digits.replace(/\D/g, '').slice(0, 11);
  const part1 = d.slice(0, 3);
  const part2 = d.slice(3, 6);
  const part3 = d.slice(6, 9);
  const part4 = d.slice(9, 11);

  let formatted = part1;
  if (part2) formatted += `.${part2}`;
  if (part3) formatted += `.${part3}`;
  if (part4) formatted += `-${part4}`;
  return formatted;
};

export const isValidCPF = (cpfDigits: string) => {
  const cpf = cpfDigits.replace(/\D/g, '');
  if (!cpf || cpf.length !== 11) return false;

  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calc = (t: number) => {
    let sum = 0;
    for (let i = 0; i < t - 1; i += 1) {
      sum += Number(cpf.charAt(i)) * (t - i);
    }
    const res = (sum * 10) % 11;
    return res === 10 ? 0 : res;
  };

  const v1 = calc(10);
  const v2 = calc(11);
  return v1 === Number(cpf.charAt(9)) && v2 === Number(cpf.charAt(10));
};

export const formatZipCodeMasked = (digits: string) => {
  const d = digits.replace(/\D/g, '').slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
};
